import { render, staticRenderFns } from "./PrivateAgreePopup.vue?vue&type=template&id=816a16fe&scoped=true&"
import script from "./PrivateAgreePopup.vue?vue&type=script&lang=js&"
export * from "./PrivateAgreePopup.vue?vue&type=script&lang=js&"
import style0 from "./PrivateAgreePopup.vue?vue&type=style&index=0&id=816a16fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "816a16fe",
  null
  
)

export default component.exports